import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { changeJob, fetchSingleJob } from "../../features/jobs/jobsSlice";

const EditJobForm = () => {
    const [title, setTitle] = useState("");
    const [type, setType] = useState("");
    const [salary, setSalary] = useState("");
    const [deadline, setDeadline] = useState("");

    const dispatch = useDispatch();

    const { job } = useSelector((state) => state.jobs);

    const {
        id,
        title: jobTitle,
        type: jobType,
        salary: jobSalary,
        deadline: jobDeadline,
    } = job || {};

    const { jobId } = useParams();

    const navigate = useNavigate();

    const resetForm = () => {
        setTitle("");
        setType("");
        setSalary("");
        setDeadline("");
    };

    useEffect(() => {
        dispatch(fetchSingleJob(jobId));
        if (id) {
            setTitle(jobTitle);
            setType(jobType);
            setSalary(jobSalary);
            setDeadline(jobDeadline);
        }
    }, [dispatch, jobId, id, jobTitle, jobType, jobSalary, jobDeadline]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const data = {
            id,
            title,
            type,
            salary,
            deadline,
        };
        dispatch(changeJob({ id, data }));
        resetForm();
        navigate("/");
        toast.success("Job updated successfully");
    };

    return (
        <form className="space-y-6" onSubmit={handleSubmit}>
            <div className="fieldContainer">
                <label
                    htmlFor="lws-JobTitle"
                    className="text-sm font-medium text-slate-300"
                >
                    Job Title
                </label>
                <select
                    id="lws-JobTitle"
                    name="lwsJobTitle"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                >
                    <option value="" hidden>
                        Select Job
                    </option>
                    <option>Software Engineer</option>
                    <option>Software Developer</option>
                    <option>Full Stack Developer</option>
                    <option>MERN Stack Developer</option>
                    <option>DevOps Engineer</option>
                    <option>QA Engineer</option>
                    <option>Product Manager</option>
                    <option>Social Media Manager</option>
                    <option>Senior Executive</option>
                    <option>Junior Executive</option>
                    <option>Android App Developer</option>
                    <option>IOS App Developer</option>
                    <option>Frontend Developer</option>
                    <option>Frontend Engineer</option>
                </select>
            </div>

            <div className="fieldContainer">
                <label htmlFor="lws-JobType">Job Type</label>
                <select
                    id="lws-JobType"
                    name="lwsJobType"
                    value={type}
                    onChange={(e) => setType(e.target.value)}
                    required
                >
                    <option value="" hidden>
                        Select Job Type
                    </option>
                    <option>Full Time</option>
                    <option>Internship</option>
                    <option>Remote</option>
                </select>
            </div>

            <div className="fieldContainer">
                <label htmlFor="lws-JobSalary">Salary</label>
                <div className="flex border rounded-md shadow-sm border-slate-600">
                    <span className="input-tag">BDT</span>
                    <input
                        type="number"
                        name="lwsJobSalary"
                        id="lws-JobSalary"
                        required
                        className="!rounded-l-none !border-0"
                        placeholder="20,00,000"
                        value={salary}
                        onChange={(e) => setSalary(e.target.value)}
                    />
                </div>
            </div>

            <div className="fieldContainer">
                <label htmlFor="lws-JobDeadline">Deadline</label>
                <input
                    type="date"
                    name="lwsJobDeadline"
                    id="lws-JobDeadline"
                    required
                    value={deadline}
                    onChange={(e) => setDeadline(e.target.value)}
                />
            </div>

            <div className="text-right">
                <button
                    type="submit"
                    id="lws-submit"
                    className="cursor-pointer btn btn-primary w-fit"
                >
                    Edit
                </button>
            </div>
        </form>
    );
};

export default EditJobForm;
